import "./styles.scss";
import React, { useState, useRef, useEffect } from "react";
import { FaCheck } from "react-icons/fa";

const MEditableDisplay = ({ label, onChange, placeholder, type = "number" }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [inputText, setInputText] = useState(label);

  useEffect(() => {
    setInputText(label);
  }, [label]);

  const inputRef = useRef(null);

  const onToggleEdit = () => {
    setIsEditing(true);
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  const onConfirmEdit = () => {
    onChange(inputText);
    setIsEditing(false);
  };

  return (
    <div className="flex items-center text-sm text-[#171717] border-solid border-1 border-[#E5E5E5] rounded-md px-[4px] py-[4px] outline-none border-0 w-full">
      {!isEditing && (
        <div
          className="grow cursor-pointer hover:bg-[#F5F5F5]"
          onClick={onToggleEdit}
          onKeyDown={onToggleEdit}
        >
          {label || <span className="text-[#404040]/[0.4]">{placeholder}</span>}
        </div>
      )}
      <input
        ref={inputRef}
        className={`w-full outline-none border-0${isEditing ? "" : " w-[0px] h-[0px]"}`}
        type={type}
        placeholder={placeholder}
        value={inputText}
        onChange={(e) => setInputText(e.target.value)}
      />
      {isEditing && (
        <div
          className="cursor-pointer hover:bg-[#F5F5F5] p-[4px]"
          onClick={onConfirmEdit}
          onKeyDown={onConfirmEdit}
        >
          <FaCheck color="#4318FF" />
        </div>
      )}
    </div>
  );
};

export default MEditableDisplay;
